/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowWeekendAdventureTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowWeekendAdventure,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Explore the Outdoors!",
    "Weekend Adventure Awaits!",
    "Discover New Trails!",
  ],
  title: "Weekend Adventure",
  description: "Organize an exciting weekend adventure.",
  longDescription:
    "Gather your friends for a weekend adventure! Choose a date, decide on activities, and plan transportation!",
  emoji: "🚗",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Weekend Adventure",
          emoji: "🚗",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go on our weekend adventure?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities to do?",
            description:
              "What activities should we include during the weekend adventure?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we consider?",
                emoji: "🏞",
                completeAction: {
                  question: "Decide on meals?",
                  description: "What meals should we plan for the adventure?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What meals should we bring?",
                      emoji: "🍔",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Hit the Road!",
    outroDescription:
      "Your weekend adventure plans are set! Enjoy the exploration!",
  },
};
